import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const WatchlistApproval = {
	name: NAME,
	router,
	apiProvider,
};
